import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import { Routes, Route, Navigate } from 'react-router-dom'
import ForgotPassword from './ForgotPassword/ForgotPassword'

// const ForgotPassword = lazy(() => import('./ForgotPassword/ForgotPassword'))

export default function AuthRoute() {
  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ErrorBoundaryComponent>
  )
}
